export const LedgerDetails = () => import("./LedgerDetails.vue");
